import React, { useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import Box from '../Box';
import useTheme from '../../hooks/useTheme';
import { StyledIndicator, StyledTabsLinks, StyledTabNavLink, StyledTabs } from './styled';

const TabsLinks = ({ tabs, rightContent, small }) => {
    const tabsEl = useRef();
    const location = useLocation();
    const theme = useTheme();
    const [posIndicator, setPosIndicator] = useState();

    useLayoutEffect(() => {
        const tabsChildrenEl = [...tabsEl.current?.children ?? []];
        const findedActiveTabEl = tabsChildrenEl.find(tabEl => tabEl.classList.contains('active'));
        setPosIndicator({
            width: findedActiveTabEl?.offsetWidth ?? 0,
            left: findedActiveTabEl?.offsetLeft ?? 0
        });
    }, [location]);

    return (
        <StyledTabsLinks>
            <StyledTabs ref={tabsEl}>
                {tabs && tabs.map(tab => (
                    <StyledTabNavLink
                        small={small}
                        key={tab.to}
                        to={tab.to}
                        activeStyle={{
                            color: theme.colors.darkGrey
                        }}
                    >
                        {tab.name}
                    </StyledTabNavLink>
                ))}
                <StyledIndicator style={posIndicator} />
            </StyledTabs>
            {
                rightContent &&
                <Box>
                    {rightContent}
                </Box>
            }
        </StyledTabsLinks>
    );
};

TabsLinks.propTypes = {
    tabs: PropTypes.array,
    rightContent: PropTypes.node
};

export default React.memo(TabsLinks);
